import { atom } from 'jotai';

export const aemContent = atom({});
export const aemDisclosureItems = atom<Map<number, Disclosures>>(new Map());
export const aemError = atom({});
export const dashboardData = atom({});
export const vehicleDetailsData = atom({});
export const vehicleDetailsApiError = atom({});
export const selectedFilters = atom({} as any);
export const dashboardApiError = atom({});
export const dashboardTabIndex = atom(1);
export const detailedAssessmentAemData = atom({});
export const batteryPackLabelsFromAemData = atom({});
export const detailedAssessmentAemError = atom({});
export const dashboardNoContentApiResponse = atom({} as any);
export const bookConsultationData = atom({});
